var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundLeaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "errorBackground",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 1698,
    viewBox: "0 0 2305 1698",
    fill: "none",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1556.15 805.788C1870.4 670.876 2266.88 941.156 2283.04 964.691C2265.96 976.408 2223.89 1016.83 2192.17 1084.77C2152.51 1169.69 1481.78 1301.16 1368.06 1333.05C1254.33 1364.95 1119.92 1289.87 940.001 1159.46C1116.5 1142.18 1241.9 940.7 1556.15 805.788Z",
    fill: "#FFE2C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M945.5 965.299C620.749 965.299 390.755 870.724 -0.000436849 965.299C83.2122 809.885 277.055 451.754 440.709 328.191C741 101.465 1304.92 100.461 1631.96 453.875C1566.61 741.764 1364.75 965.299 945.5 965.299Z",
    fill: "#FFE2C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLeaves);
export default __webpack_public_path__ + "static/media/BackgroundLeaves.0f063b47366d9544d7f2ac71e642e9b7.svg";
export { ForwardRef as ReactComponent };